export default __webpack_public_path__ + "static/media/pgmico(32).75e0a77d.png";